import VueRouter from 'vue-router'
import Podat from '../page/Podat'
import kateg from '../components/kateg'
import marka from '../components/marka'
import model from '../components/model'
import god from '../components/god'
import kuzov from '../components/kuzov'
import color from '../components/color'
import topliva from '../components/topliva'
import karobka from '../components/karobka'
import privod from '../components/privod'
import obyomdvigatel from '../components/obyomdvigatel'
import opsiya from '../components/opsiya'
import contact from '../components/contact'
import info from '../components/info'
import foto from '../components/foto'
import tip from '../components/tip'
import podkateg from '../components/podkateg'
import diska from '../components/diska'

import kategObmen from '../components/kategObmen'
import obmenpodat from '../components/obmenpodat'
import markaObmen from '../components/markaObmen'
import modelObmen from '../components/modelObmen'
import razdelObmen from '../components/razdelObmen'
import tipObmen from '../components/tipObmen'
import godObmen from '../components/godObmen'

import login from '../page/login'
import cbn from '../page/cbn'
import obmen from '../page/obmen'
import edit from '../page/edit'
import obv from '../page/obv'
import favorites from '../page/favorites'
import img from '../page/img'
import settingsearch from '../page/settingsearch'
import message from '../page/message'
import chat from '../page/chat'
import bezopasnost from '../page/bezopasnost'
import pravila from '../page/pravila'
import viptop from '../page/viptop'
import fillupbalans from '../page/fillupbalans'
import obnovitdate from '../page/obnovitdate'
import kupitvin from '../page/kupitvin'
export default new VueRouter({
  mode: 'history',
   routes: [
    {
      path: '/podat',
      name: 'Podat',
      component: Podat
    },
    {
      path: '/gorod/:set',
      name: 'gorodset',
      component: Podat
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: favorites
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/podat/kateg',
      name: 'kateg',
      component: kateg
    },
    {
      path: '/podat/model/:id',
      name: 'model',
      component: model
    },
    {
      path: '/model/:id/:set',
      name: 'modelset',
      component: model
    },
    {
      path: '/model/:id/:model',
      name: 'modelmodel',
      component: model
    },
    {
      path: '/podat/kuzov',
      name: 'kuzov',
      component: kuzov
    },
    {
      path: '/kuzov/:set',
      name: 'kuzovset',
      component: kuzov
    },
    {
      path: '/podat/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/podat/diska',
      name: 'diska',
      component: diska
    },
    {
      path: '/podat/god',
      name: 'god',
      component: god
    },
    {
      path: '/podat/color',
      name: 'color',
      component: color
    },
    {
      path: '/color/:set',
      name: 'colorset',
      component: color
    },
    {
      path: '/podat/topliva',
      name: 'topliva',
      component: topliva
    },
    {
      path: '/topliva/:set',
      name: 'toplivaset',
      component: topliva
    },
    {
      path: '/podat/karobka',
      name: 'karobka',
      component: karobka
    },
    {
      path: '/karobka/:set',
      name: 'karobkaset',
      component: karobka
    },
    {
      path: '/podat/privod',
      name: 'privod',
      component: privod
    },
    {
      path: '/podat/obyomdvigatel',
      name: 'obyomdvigatel',
      component: obyomdvigatel
    },
    {
      path: '/podat/opsiya',
      name: 'opsiya',
      component: opsiya
    },
    {
      path: '/podat/info',
      name: 'info',
      component: info
    },
    {
      path: '/podat/foto',
      name: 'foto',
      component: foto
    },
    {
      path: '/podat/marka/:id',
      name: 'marka',
      component: marka
    },
    {
      path: '/marka/:id/:set',
      name: 'markaset',
      component: marka
    },
    {
      path: '/marka/:id/:marka',
      name: 'markamarka',
      component: marka
    },
    {
      path: '/podat/podkateg/:id',
      name: 'podkateg',
      component: podkateg
    },
    {
      path: '/podat/tip/:id',
      name: 'tip',
      component: tip
    },
    {
      path: '/tip/:id/:set',
      name: 'tipset',
      component: tip
    },
    {
      path: '/chat',
      name: 'chat',
      component: chat
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      beforeEnter: ( to, from, next )=>{
        if(!localStorage.getItem("token")){
          next();
        }else{
          next({name: 'cbn'})
        }
       }
    },
    {
      path: '/cbn',
      name: 'cbn',
      component: cbn
    },
    {
      path: '/pravila',
      name: 'pravila',
      component: pravila
    },
    {
      path: '/bezopasnost',
      name: 'bezopasnost',
      component: bezopasnost
    },
    {
      path: '/settingsearch/:k/:pk/:ppk',
      name: 'settingsearch',
      component: settingsearch
    },
    {
      path: '/settingsearch/:k/:pk',
      name: 'settingsearch',
      component: settingsearch
    },
    {
      path: '/settingsearch/:k',
      name: 'settingsearch',
      component: settingsearch
    },
    {
      path: '/settingsearch',
      name: 'settingsearch',
      component: settingsearch
    },
    {
      path: '/edit/:id',
      name: 'edit',
      component: edit
    },
    {
      path: '/obv/:id',
      name: 'obv',
      component: obv
      },
      {
      path: '/img/:id',
      name: 'img',
      component: img
      },
      {
        path: '/viptop',
        name: 'viptop',
        component: viptop
      },
      {
        path: '/fillupbalans',
        name: 'fillupbalans',
        component: fillupbalans
      },
      {
        path: '/obnovitdate',
        name: 'obnovitdate',
        component: obnovitdate
      },
      {
        path: '/kupitvin',
        name: 'kupitvin',
        component: kupitvin
      },
      {
        path: '/obmenpodat',
        name: 'obmenpodat',
        component: obmenpodat
      },
      {
        path: '/kategObmen',
        name: 'kategObmen',
        component: kategObmen
      },
      {
        path: '/markaObmen',
        name: 'markaObmen',
        component: markaObmen
      },
      {
        path: '/modelObmen',
        name: 'modelObmen',
        component: modelObmen
      },
      {
        path: '/razdelObmen',
        name: 'razdelObmen',
        component: razdelObmen
      },
      {
        path: '/tipObmen',
        name: 'tipObmen',
        component: tipObmen
      },
      {
        path: '/godObmen',
        name: 'godObmen',
        component: godObmen
      },
      {
        path: '/obmen',
        name: 'obmen',
        component: obmen
      },
      
       
    
  ]
});